import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UnityGame from './routes/UnityGame';

// const root = ReactDOM.createRoot(document.getElementById('root'));

// root.render(   <BrowerRouter>
//   <App />
//   </BrowerRouter>);
ReactDOM.render(
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}></Route>
      {/* <Route path="unityGame" element={<UnityGame />}></Route> */}
    </Routes>
    </BrowserRouter>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
